import React from "react"
import classes from "./PaymentMethodBox.module.css"
import CustomRadioButton from "../../../../../ui/atoms/RadioButton"

interface Props {
  selected: boolean
  onSelect: () => void
  label: React.ReactNode
  icons: string[]
  iconsWidth?: number | string
  className?: string
  id: string
}

const PaymentMethodBox = ({
  selected,
  onSelect,
  label,
  icons,
  iconsWidth,
  className,
  id,
}: Props) => {
  return (
    <div id={id} className={`${classes.root} ${className}`} onClick={onSelect}>
      <CustomRadioButton value={selected} classes={{ label: classes.label }}>
        {label}
      </CustomRadioButton>
      <div className={classes.logos}>
        {icons.map((x, index) => (
          <img
            key={index}
            src={x}
            className={classes.logo}
            width={iconsWidth}
          />
        ))}
      </div>
      {/* <CustomRow justify="flex-end" className={classes.logos}>
        {icons.map((x, index) => (
          <CustomCol sm={2} xs={4} key={index}>
            <img src={x} className={classes.logo} width={iconsWidth} />
          </CustomCol>
        ))}
      </CustomRow> */}
    </div>
  )
}

export default PaymentMethodBox
